module.exports = __webpack_public_path__ + "img/Highlight_Feature-B.59b23794.png";